export enum AverageTime {
    MINUTES_15 = '900000',
    MINUTES_30 = '1800000',
    MINUTES_45 = '2700000',
    HOUR_1 = '3600000',
    HOUR_QUARTER = '4500000',
    HOUR_HALF = '5400000'
}
